import IFilePreview from '../interfaces/IFilePreview';

export default function filePreviewState(): IFilePreview {
  return {
    fileId: null,
    files: [],
    track: false,
  };
}
